import React from 'react'
import styled from '@emotion/styled'
import type { BetSlipItem, FobDetails } from '@mobi/betslip/types'
import { Icon } from '@mobi/component-library/Common/Icon'
import { MarketPillStyled, HeaderWrapperStyled } from '../Common/MultiHeader.styles'

export const FobHeader: React.FC<{
  selectionDetails: FobDetails
  betLegType: BetSlipItem['multiLegBetType']
}> = ({ selectionDetails, betLegType }) => {
  const {
    sportIconCode,
    tournamentName,
    competitionName,
    eventName,
    marketName,
    propositionName,
    handicapName,
  } = selectionDetails

  return (
    <HeaderWrapperStyled>
      <MarketPillStyled>
        <Icon size='1.6rem' type={sportIconCode} />

        {tournamentName ? (
          <span>
            {competitionName} {tournamentName}
          </span>
        ) : (
          <span>{competitionName}</span>
        )}

        {eventName !== marketName && eventName && <span>{eventName}</span>}
      </MarketPillStyled>

      <SingleSelectionStyled data-tid-single-selection>
        {propositionName} {handicapName ? handicapName : ''}
      </SingleSelectionStyled>

      <span>{betLegType === 'W' ? 'Win' : 'Place'}</span>
    </HeaderWrapperStyled>
  )
}

// ======
// Styles
// ======

const SingleSelectionStyled = styled.div({
  fontSize: '1.6rem',
  fontWeight: 'bold',
  lineHeight: 'normal',
  padding: '1rem 0 0',
  wordBreak: 'break-all',
  wordWrap: 'normal',
})
